import React from "react"
import styled from "styled-components"
import { HeaderHeight } from "../../components/templates/header/style/variables"
import Width from "../../style/enum/width"
import { ChatEditor } from "./components/chat-editor"
import { GuestIcon } from "./components/guest-icon"
import { SelectPostAccount } from "./components/select-post-account"
import { Tags } from "./components/tags"
import { Title } from "./components/title"
import { Header } from "./components/header"
import { Wrapper } from "../../components/templates/wrapper"
import { CreateSurvey } from "./components/modals/create-survey"

export const EditorMain = () => {
  return (
    <>
      <Header />
      <StyledWrapper maxWidth={Width.EPISODE}>
        <SelectPostAccount />
        <GuestIcon />
        <Title />
        <ChatEditor />
        <Tags />
      </StyledWrapper>
      {/* modals */}
      <CreateSurvey />
    </>
  )
}

const StyledWrapper = styled(Wrapper)`
  padding: ${HeaderHeight}px 15px 50px;
`
